module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "the-login-form p-lg-5 p-md-4 p-3"
  }, [_c('h3', [_vm._v("Vstup do zákaznické samoobsluhy")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "autocomplete": "on"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "inputUsername"
    }
  }, [_vm._v("Klientské číslo")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputUsername),
      expression: "inputUsername"
    }],
    ref: "username",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "name": "username",
      "autocomplete": "username",
      "disabled": _vm.submitPending,
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.inputUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputUsername = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Heslo")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputPassword),
      expression: "inputPassword"
    }],
    ref: "password",
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "disabled": _vm.submitPending,
      "autocomplete": "current-password"
    },
    domProps: {
      "value": (_vm.inputPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputPassword = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.incompleteForm || _vm.submitPending
    },
    on: {
      "click": _vm.submitForm
    }
  }, [(!_vm.submitPending) ? _c('span', [_vm._v("Přihlásit")]) : _vm._e(), _vm._v(" "), (_vm.submitPending) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.goToResetPassword
    }
  }, [_vm._v("\n          Vytvořit nový přístup - obnova zapomenutého hesla\n        ")])]), _vm._v(" "), (_vm.displayError) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-12 error-box"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        " + _vm._s(_vm.displayError) + "\n      ")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8"
  }, [_c('small', [_vm._v("Klientské číslo je sedmimístné, např. 1012233. Odpovídá variabilnímu symbolu, který používáte pro platby trvalým příkazem za služby společnosti Rychlý drát, s.r.o. Na výpisu z Vaší banky jej najdete u odchozích plateb ve prospěch účtu 344355366/2010.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed47c0d6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 330
// module chunks = 1 2